import React from 'react';
import { Box, Container, Grid, Link, Typography } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

import { AppleButton } from '@buttons/AppleButton';
import { GoogleButton } from '@buttons/GoogleButton';
//import LogoLight from '@assets/images/logo-light.png';
import LogoWhite from '@assets/images/LogoWhite.svg';
import { productos, contactanos, clientes } from './data';

export const Footer: React.FC = () => (
  <Box
    component={'footer'}
    sx={{ bgcolor: '#282828' }}
    zIndex={10}
    position={'relative'}
  >
    <Container maxWidth={'xl'}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <Box
            component={'img'}
            src={LogoWhite}
            sx={{
              width: { xs: 180, md: 160 },
              maxWidth: { xs: 180, md: 180 },
            }}
            alt={'Inter, seguro, seguro'}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Box display={'flex'} flexDirection={'column'}>
            <Typography
              variant={'subtitle1'}
              color={'white'}
              fontWeight={'bold'}
            >
              {'Productos'}
            </Typography>
            <Box marginBottom={3} />
            {productos.map((item: { name: string; url: string }, index) => (
              <Link
                href={item.url}
                target="_blank"
                variant={'subtitle1'}
                key={`${item.url}-${index}`}
                style={{
                  cursor: 'pointer',
                  color: 'white',
                  textDecoration: 'none',
                }}
              >
                {item.name}
              </Link>
            ))}
          </Box>
          <Box marginBottom={2} />
          <Typography variant={'subtitle1'} color={'white'} fontWeight={'bold'}>
            {'Protección de datos'}
          </Typography>
          {clientes.map((item: { name: string; url: string }, index) => (
            <Link
              href={item.url}
              target={'_blank'}
              style={{ textDecoration: 'none' }}
            >
              <Typography
                key={`${item}-${index}`}
                variant={'subtitle1'}
                color={'white'}
              >
                {item.name}
              </Typography>
            </Link>
          ))}
        </Grid>
        <Grid item xs={12} md={3}>
          <Box display={'flex'} flexDirection={'column'}>
            <Typography
              variant={'subtitle1'}
              color={'white'}
              fontWeight={'bold'}
              style={{ cursor: 'pointer' }}
            >
              {'Contáctanos'}
            </Typography>
            <Box marginBottom={2} />
            {contactanos.map((item: string, index: number) =>
              index === 0 ? (
                <Link
                  href={`tel:${item.replaceAll(' ', '')}`}
                  target={'_blank'}
                  style={{ textDecoration: 'none' }}
                >
                  <Typography
                    key={item}
                    variant={'subtitle1'}
                    color={'white'}
                    style={{ cursor: 'pointer' }}
                  >
                    {item}
                  </Typography>
                </Link>
              ) : (
                <Link
                  href={`mailto:${item.replaceAll(' ', '')}`}
                  target={'_blank'}
                  style={{ textDecoration: 'none' }}
                >
                  <Typography
                    key={item}
                    variant={'subtitle1'}
                    color={'white'}
                    style={{ cursor: 'pointer' }}
                  >
                    {item}
                  </Typography>
                </Link>
              )
            )}
            {/*<Box marginBottom={4} />
            <Typography
              variant={'subtitle1'}
              color={'white'}
              fontWeight={'bold'}
            >
              {'Clientes'}
            </Typography>*/}
          </Box>
        </Grid>
        <Grid item xs={12} md={3}>
          <Box display={'flex'} flexDirection={'column'}>
            <Typography
              variant={'subtitle1'}
              color={'white'}
              fontWeight={'bold'}
            >
              {'Descarga nuestra app'}
            </Typography>
            <Box
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              marginTop={2}
            >
              <Link
                href="https://apps.apple.com/mx/app/intermx/id1548367767?l=en"
                target={'_blank'}
                style={{ textDecoration: 'none' }}
              >
                <AppleButton />
              </Link>
              <Box marginLeft={0.8} />
              <Link
                href="https://play.google.com/store/apps/details?id=grut.inter.mx"
                target={'_blank'}
                style={{ textDecoration: 'none' }}
              >
                <GoogleButton />
              </Link>
            </Box>
            <Box marginBottom={4} />
            <Typography
              variant={'subtitle1'}
              fontWeight={'bold'}
              color={'white'}
            >
              {'Síguenos en redes sociales'}
            </Typography>
            <Box marginTop={'10px'}>
              <Link href="https://www.facebook.com/intermx" target={'_blank'}>
                <FacebookIcon
                  style={{
                    color: 'grey',
                    marginRight: '28.06px',
                    cursor: 'pointer',
                  }}
                />
              </Link>
              <Link href="https://www.instagram.com/intermx/" target={'_blank'}>
                <InstagramIcon
                  style={{
                    color: 'grey',
                    marginRight: '28.06px',
                    cursor: 'pointer',
                  }}
                />
              </Link>
              <Link
                href="https://www.linkedin.com/company/interproteccion/"
                target={'_blank'}
              >
                <LinkedInIcon
                  style={{
                    color: 'grey',
                    marginRight: '28.06px',
                    cursor: 'pointer',
                  }}
                />
              </Link>
              <Link
                href="https://www.youtube.com/channel/UCZ8wH2JLzDYvvrN-JiG3roA/videos"
                target={'_blank'}
              >
                <YouTubeIcon
                  style={{
                    color: 'grey',
                    cursor: 'pointer',
                  }}
                />
              </Link>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box paddingY={2} />
      <Box marginBottom={4} />
      <Box
        paddingY={1}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Typography
          textAlign={'center'}
          variant={'caption'}
          color={'white'}
          style={{ fontWeight: 300 }}
        >
          {'Copyright 2021 ® Interprotección'}
        </Typography>
      </Box>
    </Container>
  </Box>
);
